<template>
  <div class="news-content-container">
    <div class="news-content">
      <div class="content" v-show="!isShowNullInfo">
        <div v-show="allList.length" v-for="item in allList" :key="item.id" class="content-item">
          <div class="content-item-img">
            <img :src="item.imgUrl" alt />
          </div>
          <div class="content-item-text">
            <div class="content-item-text-title">
              <span @click="jumpRouter(item)">
                {{
                item.title
                }}
              </span>
            </div>
            <div class="content-item-text-brief">{{ item.summary }}</div>
            <div class="content-item-text-navigation">
              <span
                :style="{ backgroundColor: item.bgColor, color: item.fontColor }"
              >{{ $getConfigText(item.typeName) }}</span>
              <span>{{ item.publishTime.split(" ")[0] }}</span>
            </div>
          </div>
        </div>
        <div v-show="!allList.length" class="empty-content">
          <img :src="cdn_home_img + '/paas/empty.png'" alt />
          <span>{{$t('paas_system.system.news_null')}}</span>
        </div>
      </div>
      <div v-show="isShowNullInfo" class="null-content">
        <img :src="cdn_img_prefix + '/news/news_null_msg.png'" alt />
        <span class="null-span-top">{{$t('home.CoSub.news.sorry_no_find_1')}}</span>
        <span class="null-span-bottom">{{$t('home.CoSub.news.sorry_no_find_2')}}</span>
      </div>
      <!-- <div v-show="isShowEmptyContent" class="empty-content">
        <img :src="cdn_img_prefix + '/news/news_empty.jpg'" alt />
        <span>暂无内容</span>
      </div> -->
      <el-pagination
        v-show="showPage"
        background
        layout="prev, pager, next"
        :total="paginationTotal"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { commonParams } from "@/config/common.js";

export default {
  name: "news_content",
  props: {
    route: {
      type: String,
      default: "all"
    },
    searchList: {
      type: Array,
      default: []
    },
    allList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isShowEmptyContent: false,
      isShowNullInfo: false,
      currentList: [],
      paginationTotal: 0,
      pageSize: 10,
      currentPage: 1
    };
  },
  computed: {
    cdn_home_img() {
      return commonParams.CDN_HOME_IMG;
    },
    cdn_img_prefix(){
      return commonParams.CDN_IMG_PREFIX;
    },
    showPage(){
      return !(this.isShowEmptyContent || this.isShowNullInfo)
    }
  },
  methods: {
    jumpRouter(news) {
      if(news.contentType === 1){
        window.open(news.url)
      }else{
        this.$router.push({
          path: `/newsDetail/${news.newsId}`,
          params: {
            bgColor: news.bgColor,
            fontColor: news.fontColor
          }
        })
      }
    },
    changePage(currentPage) {
      this.currentPage = currentPage;
    },
    fenye(list) {
      this.paginationTotal = list.length;
      let begin = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      this.currentList = list.slice(begin, end);
      if (this.currentList.length == 0) this.isShowEmptyContent = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.news-content-container {
  width: 1100px;
  padding-left: 20px;
  .news-content {
    width: 1080px;
    min-height: 45vh;
    .content {
      margin: 20px 0;
      .content-item {
        height: 200px;
        border-bottom: 1px solid #e1e7f2;
        padding: 20px 0;
        display: flex;
        align-items: center;
        .content-item-img {
          width: 240px;
          height: 140px;
          text-align: center;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          overflow: hidden;
          border-radius: 5px;
          background-color: #eaeaea;
          img {
            width: 100%;
          }
        }
        .content-item-text {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          margin-left: 20px;
          height: 85%;
          justify-content: space-between;
          .content-item-text-title {
            font-size: 18px;
            font-weight: bold;
            span {
              cursor: pointer;
              &:hover {
                color: #008fff;
              }
            }
          }
          .content-item-text-brief {
            width: 100%;
            line-height: 24px;
            font-size: 14px;
            margin: 10px 0 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
            color: #7f7f7f;
          }
          .content-item-text-navigation {
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
              &:first-child {
                color: white;
                padding: 3px 8px;
                min-width: 80px;
                border-radius: 20px;
                text-align: center;
                margin-right: 20px;
              }
              &:last-child {
                color: #a9a9a9;
              }
            }
          }
        }
      }
    }
    .null-content {
      width: 100%;
      height: 600px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 400px;
      }
      span.null-span-top {
        font-size: 18px;
        margin: 0 0 10px;
        color: #333;
      }
      span.null-span-bottom {
        font-size: 14px;
        color: #a9a9a9;
      }
    }
    .empty-content {
      width: 100%;
      height: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 400px;
      }
      span {
        font-size: 18px;
        margin: 0 0 10px;
        color: #333;
      }
    }
    .el-pagination {
      text-align: center;
      margin: 20px 0;
    }
  }
  .news-detail {
    width: 1080px;
    padding-top: 60px;
    .detail-title {
      font-size: 18px;
    }
    .detail-subtitle {
      padding: 20px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e1e7f2;
      span {
        font-size: 14px;
        &:first-child {
          color: white;
          padding: 3px;
          width: 80px;
          border-radius: 20px;
          text-align: center;
          margin-right: 20px;
        }
        &:last-child {
          color: #a9a9a9;
        }
      }
    }
    .detail-content {
      padding: 50px 0;
      width: 100%;
      font-size: 14px;
      line-height: 40px;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/news/content.vue